/**
 * Phones and tablets (iOS / iPadOS / Android). Their browsers kill a tab at a
 * far lower memory ceiling than desktops (iOS Safari reloads the page at
 * roughly 1–1.5 GB), so the viewer caps point budgets and texture sizes there.
 *
 * iPadOS reports a desktop Mac user agent, so it is told apart from a real Mac
 * by its touch points. Plain touch support is not enough: touch-screen laptops
 * have desktop memory.
 */
export function isMobileDevice(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  if (/iPhone|iPad|iPod|Android/i.test(ua)) return true;
  return /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;
}
